var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_189",
    "data-name": "Ret\\xE2ngulo 189",
    width: 58,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa-2",
    "data-name": "visa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_196",
    "data-name": "Ret\\xE2ngulo 196",
    stroke: "#e7e7e7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 40,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_555",
    "data-name": "Grupo 555",
    transform: "translate(9.744 13.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_554",
    "data-name": "Grupo 554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_184",
    "data-name": "Caminho 184",
    d: "M56.346,64.258H53.2l1.964-12.072h3.142Z",
    transform: "translate(-39.65 -51.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_185",
    "data-name": "Caminho 185",
    d: "M22.137,52.193l-3,8.3-.354-1.788h0l-1.058-5.428a1.346,1.346,0,0,0-1.49-1.088h-4.95l-.058.2a11.74,11.74,0,0,1,3.288,1.38l2.73,10.486h3.274l5-12.072Z",
    transform: "translate(-11.227 -51.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_186",
    "data-name": "Caminho 186",
    d: "M104.175,64.261h2.886l-2.516-12.072h-2.526a1.444,1.444,0,0,0-1.452.9L95.881,64.261h3.276l.656-1.8h4Zm-3.456-4.27,1.652-4.518.928,4.518Z",
    transform: "translate(-68.547 -51.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_187",
    "data-name": "Caminho 187",
    d: "M77.88,54.64l.448-2.6a9.072,9.072,0,0,0-2.826-.526c-1.56,0-5.262.682-5.262,4,0,3.118,4.346,3.158,4.346,4.8s-3.9,1.344-5.186.312l-.468,2.71a8.8,8.8,0,0,0,3.548.682c2.144,0,5.38-1.112,5.38-4.132,0-3.138-4.386-3.43-4.386-4.8S76.534,53.9,77.88,54.64Z",
    transform: "translate(-50.3 -51.514)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_188",
    "data-name": "Caminho 188",
    d: "M18.787,58.708,17.729,53.28a1.346,1.346,0,0,0-1.49-1.088H11.285l-.058.2a12.184,12.184,0,0,1,4.664,2.342A9.414,9.414,0,0,1,18.787,58.708Z",
    transform: "translate(-11.227 -51.968)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.e154547cc114634a371176b56a73383e.svg";
export { ForwardRef as ReactComponent };